export const cepMask = (value: string) => {
  return value
    ?.replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1')
}

export const cpfMask = (value: string) => {
  return value
    ?.replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\.\d{3})(\d)/, '$1.$2')
    .replace(/(\.\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

export const cnpjMask = (value: string) => {
  return value
    ?.replace(/[^a-zA-Z0-9]/g, '')
    .replace(/([a-zA-Z0-9]{2})([a-zA-Z0-9])/, '$1.$2')
    .replace(/(\.[a-zA-Z0-9]{3})([a-zA-Z0-9])/, '$1.$2')
    .replace(/(\.[a-zA-Z0-9]{3})([a-zA-Z0-9])/, '$1/$2')
    .replace(/([a-zA-Z0-9]{4})([a-zA-Z0-9])/, '$1-$2')
    .replace(/(-[a-zA-Z0-9]{2})[a-zA-Z0-9]+?$/, '$1')
}

export const cellphoneMask = (value: string) => {
  return value
    ?.replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\s\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')
}

export const phoneMask = (value: string) => {
  return value
    ?.replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\s\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')
}

export const singleDigitMask = (value: string) => {
  return value.replace(/\D/g, '').slice(0, 1)
}

export const pixRandomKeyMask = (value: string) => {
  const hex = String(value ?? '')
    .replace(/[^a-fA-F0-9]/g, '')
    .toUpperCase()
    .slice(0, 32)

  if (!hex) return ''

  const part1 = hex.slice(0, 8)
  const part2 = hex.slice(8, 12)
  const part3 = hex.slice(12, 16)
  const part4 = hex.slice(16, 20)
  const part5 = hex.slice(20, 32)

  return [part1, part2, part3, part4, part5].filter(Boolean).join('-')
}

export const pixCnpjMask = (value: string) => {
  const alphaNum = String(value ?? '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .slice(0, 14)

  const part1 = alphaNum.slice(0, 2)
  const part2 = alphaNum.slice(2, 5)
  const part3 = alphaNum.slice(5, 8)
  const part4 = alphaNum.slice(8, 12)
  const part5 = alphaNum.slice(12, 14)

  if (!alphaNum) return ''

  if (alphaNum.length <= 2) return part1
  if (alphaNum.length <= 5) return `${part1}.${part2}`
  if (alphaNum.length <= 8) return `${part1}.${part2}.${part3}`
  if (alphaNum.length <= 12) return `${part1}.${part2}.${part3}/${part4}`

  return `${part1}.${part2}.${part3}/${part4}-${part5}`
}


export const pixPhoneMask = (value: string) => {
  const digits = String(value ?? '').replace(/\D/g, '')
  const withCountryCode = digits.startsWith('55') ? digits : `55${digits}`
  const limited = withCountryCode.slice(0, 13)

  return `+${limited}`
}

export const unmaskPixKey = (value?: string | null, tipoChavePix?: string) => {
  if (value === undefined || value === null) return undefined

  if (tipoChavePix === 'CPF') {
    return String(value).replace(/\D/g, '')
  }

  if (tipoChavePix === 'CNPJ') {
    return String(value)
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase()
  }

  if (tipoChavePix === 'Chave Aleatória') {
    return String(value)
      .replace(/[^a-fA-F0-9]/g, '')
      .toUpperCase()
      .slice(0, 32)
  }

  if (tipoChavePix === 'Telefone') {
    const digits = String(value).replace(/\D/g, '')
    const withCountryCode = digits.startsWith('55') ? digits : `55${digits}`

    return withCountryCode.slice(0, 13)
  }

  return String(value).trim()
}

